import alertSettings from '../ducks/alertSettings/reducers';
import alertSettingsV3 from '../ducks/alertSettingsV3/reducers';
import alerts from '../ducks/alerts/reducers';
import analytics from '../ducks/analytics/reducers';
import appSettings from '../ducks/appSettings/reducers';
import assignedAlerts from '../ducks/assignedAlerts/reducers';
import { combineReducers } from 'redux';
import config from '../ducks/config/reducers';
import dashboard from '../ducks/dashboard/reducers';
import downTimeCategories from '../ducks/downTimeCategories/reducers';
import downtimes from '../ducks/downtimes/reducers';
import downtimesPareto from '../ducks/downtimes-pareto/reducers';
import historical from '../ducks/historical/reducers';
import i18n from '../ducks/i18n/reducers';
import layout from '../ducks/layout/reducers';
import machine from '../ducks/machine/reducers';
import machines from '../ducks/machines/reducers';
import mainDashboard from '../ducks/main-dashboard/reducers';
import modal from '../_clean-code/ducks/modal/reducers';
import notifications from '../ducks/notifications/reducers';
import production from '../_clean-code/ducks/production/reducers';
import realtime from '../_clean-code/ducks/realtime/reducers';
import report from '../ducks/report/reducers';
import reports from '../ducks/reports/reducers';
import schedule from '../ducks/schedule/reducers';
import shift from '../ducks/shift/reducers';
import simpleWorkOrderNames from '../ducks/simpleWorkOrders/reducers';
import sku from '../ducks/sku/reducer';
import stops from '../ducks/stops/reducers';
import stopsV3 from '../_clean-code/ducks/stops/reducers';
import operatorTimeline from '../_clean-code/ducks/operatorTimeline/reducers';
import operatorSettings from '../_clean-code/ducks/operatorSettings/reducers';
import tags from '../_clean-code/ducks/tags/reducers';
import { reducer as toastrReducer } from 'react-redux-toastr';
import user from '../ducks/user/reducers';
import whatsNew from '../_clean-code/ducks/whatsNew/reducers';
import workOrderNames from '../ducks/workOrders/reducers';

const appReducer = combineReducers({
  user,
  notifications,
  i18n,
  toastr: toastrReducer,
  machine,
  machines,
  alerts,
  alertSettings,
  alertSettingsV3,
  assignedAlerts,
  schedule,
  report,
  downtimes,
  downTimeCategories,
  dashboard,
  mainDashboard,
  historical,
  downtimesPareto,
  appSettings,
  shift,
  stops,
  tags,
  layout,
  realtime,
  config,
  stopsV3,
  sku,
  production,
  whatsNew,
  reports,
  analytics,
  workOrderNames,
  simpleWorkOrderNames,
  operatorTimeline,
  modal,
  operatorSettings
});

export default appReducer;
